import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Layout from '../components/Layout';
import { authdApiRequest } from '../utils/api';

function QuestionForm() {
  const { id } = useParams();
  const [question, setQuestion] = useState('');
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState('');
  const [isFreeText, setIsFreeText] = useState(true);
  const [likertScale, setLikertScale] = useState(['', '', '', '', '']);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch topics for the select box
    authdApiRequest(`${process.env.REACT_APP_API_HOST}/topics`)
      .then(response => response.json())
      .then(data => setTopics(data))
      .catch(error => {
        console.error('Error fetching topics:', error);
        toast.error('Failed to load topics.');
      });

    if (id) {
      // Fetch existing question data
      authdApiRequest(`${process.env.REACT_APP_API_HOST}/questions/${id}`)
        .then(response => response.json())
        .then(data => {
          setQuestion(data.question);
          setSelectedTopic(data.topicId);
          setIsFreeText(data.isFreeText);
          setLikertScale(data.likertScale || ['', '', '', '', '']);
        })
        .catch(error => {
          console.error('Error fetching question:', error);
          toast.error('Failed to load question data.');
        });
    }
  }, [id]);

  useEffect(() => {
    document.title = id ? `Edit ${question} - DevWing` : 'Create New Question - DevWing';
  }, [id, question]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = id ? 'PUT' : 'POST';
    const url = id ? `${process.env.REACT_APP_API_HOST}/questions/${id}` : `${process.env.REACT_APP_API_HOST}/questions`;

    try {
      await authdApiRequest(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
            "question": question,
            "topicId": selectedTopic,
            isFreeText,
            likertScale
        }),
      });
      toast.success(`Question ${id ? 'updated' : 'created'} successfully!`);
      navigate('/questions');
    } catch (error) {
      console.error('Error saving question:', error);
      toast.error('Failed to save question.');
    }
  };

  return (
    <Layout>
      <h1 className="text-2xl mb-8 font-bold">{id ? 'Edit Question' : 'Create Question'}</h1>
      <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
        <input
          type="text"
          placeholder="Question"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          className="p-2 border"
        />
        <select
          value={selectedTopic}
          onChange={(e) => setSelectedTopic(e.target.value)}
          className="p-2 border"
        >
          <option value="">Select a topic</option>
          {topics.map(topic => (
            <option key={topic.id} value={topic.id}>{topic.name}</option>
          ))}
        </select>
        <div>
          <label>
            <input
              type="radio"
              checked={isFreeText}
              onChange={() => setIsFreeText(true)}
              className='mr-2'
            />
            Free Text
          </label>
        </div>
        <div>
          <label>
            <input
              type="radio"
              checked={!isFreeText}
              onChange={() => setIsFreeText(false)}
              className='mr-2'
            />
            Likert Scale
          </label>
        </div>
        {!isFreeText && (
          <div className="flex flex-col space-y-2">
            {likertScale.map((value, index) => (
              <input
                key={index}
                type="text"
                placeholder={`Likert Scale ${index - 2}`}
                value={value}
                onChange={(e) => {
                  const newScale = [...likertScale];
                  newScale[index] = e.target.value;
                  setLikertScale(newScale);
                }}
                className="p-2 border"
              />
            ))}
          </div>
        )}
        <button type="submit" className="p-2 bg-sky-500 text-white rounded-md">
          {id ? 'Update' : 'Create'}
        </button>
      </form>
    </Layout>
  );
}

export default QuestionForm;
